import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCloudLinks';
/** Renders an SVG icon. */
const SvgCloudLinks = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M10 17v6H8.826A2.998 2.998 0 0 0 3 24a3 3 0 0 0 5.826 1H10a2 2 0 0 0 2-2v-6a1 1 0 1 0-2 0m-5 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0m12 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 0a3 3 0 0 0-2-2.825V17a1 1 0 1 0-2 0v6.175A2.998 2.998 0 0 0 16 29a3 3 0 0 0 3-3m8-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 0a3 3 0 0 0-5.826-1H22v-3.5a1 1 0 1 0-2 0V21a2 2 0 0 0 2 2h1.174A2.998 2.998 0 0 0 29 22"
      />
      <path
        fill="currentColor"
        d="M25 13.556C25 14.818 23.842 16 22.224 16H9.776C8.158 16 7 14.818 7 13.556c0-.813.49-1.631 1.377-2.094a1 1 0 0 0 .531-.998l-.023-.175-.015-.104-.003-.037C8.867 7.946 10.863 6 13.511 6c.843 0 1.665.21 2.376.599a4.5 4.5 0 0 1 1.636 1.51l.053.076a1 1 0 0 0 1.197.298q.484-.214.961-.212c1.271 0 2.147.921 2.153 1.868a1 1 0 0 0 .84 1.022c1.392.226 2.273 1.28 2.273 2.395m2 0c0-1.97-1.35-3.586-3.195-4.185-.392-1.82-2.133-3.1-4.07-3.1a4.2 4.2 0 0 0-.998.122 6.6 6.6 0 0 0-1.89-1.55A6.96 6.96 0 0 0 13.51 4c-3.542 0-6.584 2.622-6.642 6.049C5.726 10.868 5 12.146 5 13.556 5 16.092 7.23 18 9.776 18h12.448C24.77 18 27 16.092 27 13.556"
      />
    </svg>
  );
};
SvgCloudLinks.displayName = displayName;
export default SvgCloudLinks;
